// Translation for Punjabi (pa)
export const pa = {
    "common": {
        "save": "ਸੰਭਾਲੋ",
        "cancel": "ਰੱਦ ਕਰੋ",
        "close": "ਬੰਦ ਕਰੋ",
        "delete": "ਮਿਟਾਓ",
        "edit": "ਸੰਪਾਦਨ ਕਰੋ",
        "activate": "ਸਰਗਰਮ ਕਰੋ",
        "add": "ਜੋੜੋ",
        "saving": "ਸੰਭਾਲਿਆ ਜਾ ਰਿਹਾ ਹੈ...",
        "loading": "ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ...",
        "active": "ਸਰਗਰਮ",
        "inUse": "ਵਰਤੋਂ ਵਿਚ",
        "test": "ਪਰੀਖਿਆ",
        "searchApps": "ਐਪਸ ਖੋਜੋ...",
        "betaBanner": "ਬੀਟਾ - ਸੇਵਾ ਇਸ ਸਮੇ ਉਪਲਬਧ ਨਹੀ!"
    },
    "header": {
        "creditBalance": "ਬਾਕੀ",
        "minutes": "ਮਿੰਟ"
    },
    "auth": {
        "signIn": "ਸਾਈਨ ਇਨ ਕਰੋ",
        "signUp": "ਸਾਈਨ ਅਪ ਕਰੋ",
        "username": "ਉਪਭੋਗਤਾ ਨਾਮ",
        "password": "ਪਾਸਵਰਡ",
        "continue": "ਜਾਰੀ ਰੱਖੋ",
        "noAccount": "ਖਾਤਾ ਨਹੀ?",
        "hasAccount": "ਪਹਲਾਂ ਤੋਂ ਖਾਤਾ ਹੈ?",
        "loginError": "ਸਾਈਨ ਇਨ ਅਸਫਲ",
        "invalidCredentials": "ਅਮਾਨਤ ਉਪਭੋਗਤਾ ਨਾਮ ਜ ਪਾਸਵਰਡ",
        "rateLimited": "ਬਹੁਤ ਸਾਈਨ ਇਨ ਕੋਸ਼ਿਸ਼। ਸਮਾਂ ਬਤਾਓ।",
        "sessionExpired": "ਤੁਹਾਡਾ ਸੈਸ਼ਨ ਖਤਮ ਹੋ ਗਿਆ। ਨਵਾ ਜਾਦੂ ਲਿੰਕ ਵਰਤੋ।",
        "magicLinkInvalid": "ਸਾਈਨ ਇਨ ਲਿੰਕ ਅਮਾਨਤ ਜ ਖਤਮ।",
        "magicLinkSuccess": "ਸਵਾਗਤ! ਤੁਹਾਨੂ ਕਾਮਯਾਬੀ ਨਾਲ ਸਾਈਨ ਇਨ ਹੋ ਗਿਆ।",
        "magicLinkProcessing": "ਸਾਈਨ ਇਨ ਪ੍ਰਸੰਸਕਰਣ...",
        "connectionError": "ਕਨੈਕਸ਼ਨ ਗਲਤੀ। ਫੇਰ ਕੋਸ਼ਿਸ਼ ਕਰੋ।"
    },
    "profile": {
        "myProgress": "ਮੇਰੀ ਸਿੱਖਿਆ ਪ੍ਰਗਤੀ",
        "signOut": "ਸਾਈਨ ਆਊਟ",
        "plan": "ਯੋਜਨਾ:"
    },
    "settings": {
        "title": "ਸੈਟਿੰਗਸ",
        "tabs": {
            "uiSettings": "UI ਸੈਟਿੰਗਸ",
            "systemPrompt": "ਸਿਸਟਮ ਪ੍ਰੌਮਪਟ",
            "llmProfiles": "LLM ਪ੍ਰੋਫਾਈਲ",
            "ttsProfiles": "TTS ਪ੍ਰੋਫਾਈਲ",
            "language": "ਭਾਸ਼ਾ"
        },
        "uiSettings": {},
        "systemPrompt": {},
        "llmProfiles": {},
        "ttsProfiles": {},
        "language": {}},
    "chat": {
        "ready": "ਤਿਆਰ",
        "start": "ਸ਼ੁਰੂ ਕਰੋ",
        "stop": "ਰੋਕੋ",
        "initialMessage": "ਸਮ ਸਮਾਂ ਗੱਲ ਲਈ ਸ਼ੁਰੂ ਕਰੋ।",
        "listening": "ਸੁਣ ਰਿਹਾ ਹੈ...",
        "speaking": "ਥਾਰਸਟੈਨ ਬੋਲ ਰਿਹਾ ਹੈ...",
        "userLabel": "ਤੁਸੀ",
        "aiLabel": "AI",
        "modalTitle": "ਥਾਰਸਟੈਨ AI ਚੈਟ",
        "inputPlaceholder": "ਸਬਦ ਲਖੋ...",
        "send": "ਭੇਜੋ",
        "loginRequired": "ਇਹ ਸੇਵਾ ਵਰਤਣ ਲਈ ਸਾਈਨ ਇਨ ਕਰੋ।",
        "loginButton": "ਹੁਣ ਸਾਈਨ ਇਨ ਕਰੋ",
        "magicLinkRequired": "ਸਾਈਨ ਇਨ ਲਈ ਜਾਦੂ ਲਿੰਕ ਵਰਤੋ।",
        "creditLimitError": "ਤੁਹਾਡਾ ਘੰਟਾ ਕੋਟਾ ਖਤਮ। ਯੋਜਨਾ ਅਪਗ੍ਰੇਡ ਕਰੋ।",
        "serviceDisabled": "ਚੈਟ ਸੇਵਾ ਇਸ ਸਮੇਂ ਉਪਲਬਧ ਨਹੀਂ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਬਾਅਦ ਵਿੱਚ ਦੁਬਾਰਾ ਕੋਸ਼�ਸ਼ ਕਰੋ।"
    },
    "notifications": {
        "error": "ਗਲਤੀ",
        "success": "ਸਫਲਤਾ",
        "info": "ਜਾਣਕਾਰੀ",
        "unknownError": "ਅਗਿਆਤ ਗਲਤੀ ਹੋਈ"
    },
    "cookie": {
        "message": "ਇਹ ਵੈਬਸਾਇਟ ਤੁਹਾਨੂ ਵਧੀਆ ਅਨੁਭਵ ਦੇਣ ਲਈ ਕੂਕੀਆਂ ਵਰਤਦੀ ਹੈ।",
        "accept": "ਮਨਜੂਰ ਕਰੋ"
    },
        curriculum: {
                buttonLabel: 'ਪਾਠਕ੍ਰਮ',
                buttonTitle: 'ਪਾਠਕ੍ਰਮ ਸਮੱਗਰੀ ਦਿਖਾਓ',
                modalTitle: '{app} ਪਾਠਕ੍ਰਮ',
                sections: {
                    topic: 'ਪਾਠਕ੍ਰਮ ਵਿਸ਼ਾ',
                    explanation: 'ਬੱਚਿਆਂ ਲਈ ਸਮਝਾਉਣਾ',
                    studentProfile: 'ਵਿਦਿਆਰਥੀ ਪ੍ਰੋਫਾਈਲ'
                },
                topic: {
                    empty: 'ਇਸ ਮਾਈਕ੍ਰੋ-ਐਪ ਨਾਲ ਬੈਕਐਂਡ ਵਿੱਚ ਕੋਈ ਪਾਠਕ੍ਰਮ ਵਿਸ਼ਾ ਲਿੰਕ ਨਹੀਂ ਹੈ।',
                    missingDetail: 'ਇਸ ਮਾਈਕ੍ਰੋ-ਐਪ ਲਈ ਵਿਸਤ੍ਰਿਤ ਪਾਠਕ੍ਰਮ ਡੇਟਾ ਅਜੇ ਬੈਕਐਂਡ ਵਿੱਚ ਉਪਲਬਧ ਨਹੀਂ ਹੈ।',
                    learningGoals: 'ਸਿੱਖਣ ਦੇ ਟੀਚੇ',
                    prerequisites: 'ਪੂਰਵ-ਲੋੜਾਂ',
                    unitLabel: 'ਯੂਨਿਟ',
                    durationLabel: 'ਮਿਆਦ',
                    difficultyLabel: 'ਮੁਸ਼ਕਲ',
                    hours: 'ਘੰਟਾ',
                    minutes: 'ਮਿੰਟ'
                },
                explanation: {
                    empty: 'ਬੱਚਿਆਂ ਲਈ ਕੋਈ ਸਮਝਾਉਣ ਉਪਲਬਧ ਨਹੀਂ ਹੈ।',
                    loadingPrepare: 'AI ਸਮਝਾਉਣ ਤਿਆਰ ਕਰ ਰਿਹਾ ਹੈ',
                    loadingExplain: 'AI ਬੱਚਿਆਂ ਦੀ ਭਾਸ਼ਾ ਵਿੱਚ ਵਿਸ਼ਾ ਸਮਝਾ ਰਿਹਾ ਹੈ',
                    requestFailed: 'ਬੱਚਿਆਂ ਲਈ ਸਮਝਾਉਣ ਤਿਆਰ ਨਹੀਂ ਕੀਤਾ ਜਾ ਸਕਿਆ।'
                },
                studentProfile: {
                    country: 'ਦੇਸ਼',
                    region: 'ਰਾਜ / ਖੇਤਰ',
                    schoolType: 'ਸਕੂਲ ਦੀ ਕਿਸਮ',
                    grade: 'ਗ੍ਰੇਡ',
                    noContext: 'ਕੋਈ ਵਿਦਿਆਰਥੀ ਸੰਦਰਭ ਉਪਲਬਧ ਨਹੀਂ ਹੈ।',
                    childProfileNotFound: 'ਮੌਜੂਦਾ ਲੌਗਇਨ ਲਈ ਬੈਕਐਂਡ ਵਿੱਚ ਕੋਈ ਵਿਦਿਆਰਥੀ ਪ੍ਰੋਫਾਈਲ ਨਹੀਂ ਮਿਲਿਆ।',
                    loginProfileIncomplete: 'ਲੌਗਇਨ ਪ੍ਰੋਫਾਈਲ ਵਿੱਚ ਅਜੇ ਪੂਰਾ ਵਿਦਿਆਰਥੀ ਸੰਦਰਭ ਨਹੀਂ ਹੈ।',
                    educationContextNotFound: 'ਇੱਕ ਵਿਦਿਆਰਥੀ ਪ੍ਰੋਫਾਈਲ ਮਿਲਿਆ, ਪਰ ਕੋਈ ਪਾਠਕ੍ਰਮ ਅਸਾਈਨਮੈਂਟ ਸੈੱਟ ਨਹੀਂ ਹੈ।',
                    noToken: 'ਕੋਈ ਸਾਈਨ-ਇਨ ਕੀਤਾ ਵਿਦਿਆਰਥੀ ਨਹੀਂ ਮਿਲਿਆ।'
                },
                errors: {
                    signInRequired: 'ਕਿਰਪਾ ਕਰਕੇ ਪਾਠਕ੍ਰਮ ਦੇਖਣ ਲਈ ਸਾਈਨ ਇਨ ਕਰੋ।',
                    appIdMissing: 'ਐਪ ID ਗੁੰਮ ਹੈ।',
                    loadFailed: 'ਪਾਠਕ੍ਰਮ ਡੇਟਾ ਲੋਡ ਨਹੀਂ ਕੀਤਾ ਜਾ ਸਕਿਆ।'
                }
            }
    };
